module.exports = __webpack_public_path__ + "static/media/button.d1063cee.png";